module.exports = __webpack_public_path__ + "b0932347c653d09c067376edb8742d66.pdf";